export default "__VITE_ASSET__BqUHYZIf__"